import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Joyride from "react-joyride";

import Navbar from "./Navbar";
import { socket } from "services/socket";
import "react-phone-number-input/style.css";
import { setCurrentUser, updateChatAndMessage } from "states/chat/chatSlice";
import GuidedTour from "../common/GuidedTour";
import {
  creatorProfileInitialStep,
  creatorProfileSteps,
  layoutStepsBrand,
  // layoutStepsBrand,
  layoutStepsCreator,
  layoutStepsCreatorManuallyUpdateInstagramData
} from "joyride/stepsCommon";
import useJoyrideTour from "hooks/useJoyrideTour";
import { resetGuideTour, setNameTour, startTour, stopTour } from "states/guideTour/guideTourSlice";
import useElementReady from "hooks/useElementReady";
import GuidedTourV2 from "../common/GuidedTourV2";
import { cn, waitForElement } from "utils/commonUtils";



const AppLayout = ({ className, customBg, hideFooter, classNameHeader, titlePageReplaceLogoAtMobile, isDisplayHeaderAtMobile = true, isDisplayMenuAtMobile = true, children }) => {
  const dispatch = useDispatch();

  const initialLoad = useRef(true); // To prevent showing success toast on page refresh

  // Commented out because wasn't being used in here
  // const [isConnected, setIsConnected] = useState(socket.connected);


  const { user, token } = useSelector((state) => state.auth);
  const { instagramData, instagramLoading } = useSelector((state) => state.creatorDetails);
  //   const user = useSelector((state) => state.auth.user);

  // const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const location = useLocation();
  const url = location.pathname;

  const [verifyNotice, setVerifyNotice] = useState(false);
  const isForgotPassword = location.pathname === "/forgot-password";

  console.log({  isForgotPassword  })




  useEffect(() => {
    // Function to handle going offline
    const handleOffline = () => {
      toast.error("You are currently offline. Please check your network connection!");
    };

    // Function to handle going online
    const handleOnline = () => {
      // Show success toast only if it's not the initial load
      if (!initialLoad.current) {
        toast.success("Your internet connection has been restored.");
      }
    };

    // Add event listeners for online/offline events
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // Initial network status check
    if (!navigator.onLine) {
      handleOffline();
    } else {
      handleOnline();
    }

    // Mark initial load as complete
    initialLoad.current = false;

    // Cleanup listeners when the component unmounts
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [dispatch]);

  useEffect(() => {
    if (!user) return;

    let shouldShowVerifyNotice = false;
    let shouldShowVerifyNoticeInstagramData = false
    // test here
    // shouldShowVerifyNotice = true;
    console.log({ instagramData, user, " user.creator?.profile_complete":  user.creator?.profile_complete })

    if (user.role === "2") {
      if (
        user.brand?.profile_complete === 0 
        // &&
        // user.account_verified === 0
      ) {
        shouldShowVerifyNotice = true;
      }
    } else if (user.role === "1") {
      if (
        user.creator?.profile_complete === 0
        // &&
        // user.account_verified === 0
      ) {
        shouldShowVerifyNotice = true;
      }  

      if (!instagramData) {
        shouldShowVerifyNotice = true;

        localStorage.setItem("currentStep", "1");
      } else if (!instagramData?.manual_instagram_data) {
        shouldShowVerifyNoticeInstagramData = true;
      } else {
        // test here
        // shouldShowVerifyNoticeInstagramData = true;
      }
    }

    console.log({ shouldShowVerifyNotice })

    if (shouldShowVerifyNotice) {
      setVerifyNotice(true);
      dispatch(setNameTour("VerifyNotice"));
      // 👉 Stop current tour before starting new one
      dispatch(stopTour());

      const steps = user.role === "1" ? layoutStepsCreator : layoutStepsBrand;
      const firstSelector = steps[0].target;

      waitForElement(firstSelector)
        .then(() => {
          dispatch(stopTour()); // redundant nếu phía trên đã stopTour, nhưng vẫn an toàn
          dispatch(startTour(steps));
        })
        .catch((err) => {
          console.warn("Guide tour error:", err);
        });
    } else if (shouldShowVerifyNoticeInstagramData && url !== "/creatorsProfile") {

    } else {
      dispatch(setNameTour(null));
    }
  }, [user, instagramData]);


  const handleStartVerification = () => {
    if (user) {
      if (user?.role == "2") {
        navigate("/brandCompleteProfile", { state: { from: location.pathname } });

      } else if (user?.role == "1") {
        // navigate("/creatorCompleteProfile", { state: { from: location.pathname } });
        //
        // dispatch(
        //   startTour(creatorProfileInitialStep)
        // );

        navigate("/creatorCompleteProfile", {
          state: {
            from: location.pathname,
            startTour: true, // 👈 Thêm dòng này
          },
        });
        dispatch(
          stopTour(creatorProfileInitialStep)
        );
      }
    }
  };
  useEffect(() => {
    if (token !== "") {
      // Set the current user in chat reducer.
      dispatch(setCurrentUser(user));
      if (!socket.connected) {
        const handleMessageSendEvent = (object) => {
          console.log("message event", object);
          dispatch(updateChatAndMessage(object));
        };

        socket.connect();
        socket.on("connect", () => {
          socket.emit("storeUser", user?.id);
          if (token !== "") {
          }
        });
        socket.on("message_send_event", handleMessageSendEvent);
        return () => {
          socket.off("message_send_event", handleMessageSendEvent);
          socket.disconnect();
        };
      }
    }
  }, []);

  return (
    <div className={`${customBg ? customBg : "home"} ${cn("tw-overflow-hidden sm:tw-overflow-auto tw-pb-[70px] sm:tw-pb-0 sm:tw-mb-0", className)} `}>
      <header className={classNameHeader}>
        {/* There is an error always returning to the home page when on the forgotpassword page. It seems to be due to the Navbar. */}
        {/* {isForgotPassword ? <NavbarForgotPassword /> : <Navbar />} */}
        <Navbar titlePageReplaceLogoAtMobile={titlePageReplaceLogoAtMobile} isDisplayHeaderAtMobile={isDisplayHeaderAtMobile} isDisplayMenuAtMobile={isDisplayMenuAtMobile} />
        {user && verifyNotice ? (
          <>
            <div className="container verify-notice tw-mb-4">
              <div>
                Please complete your profile verification in order to be able to
                access the platform features completely...
              </div>
              <div
                onClick={() => handleStartVerification()}
                id="start-verification-btn"
                className="text-dark fw-bolder link-style-notice"
              >
                {user?.role == "1"
                  ? user?.creator?.profile_complete == "0" &&
                    (user?.creator?.profile_image_thumb === "" ||
                      user?.creator?.profile_image_thumb === null) &&
                    (user?.creator?.active_hours_from === null ||
                      user?.creator?.active_hours_from === "") &&
                    (user?.creator?.active_hours_to === null ||
                      user?.creator?.active_hours_from === "") &&
                    (user?.creator?.days === null || user?.creator?.days === "") &&
                    (user?.creator?.profile_tag === null ||
                      user?.creator?.profile_tag === "" ||
                      user?.creator?.profile_tag?.length == 0) &&
                    user?.creator?.creator_portfolios?.length == 0 &&
                    user?.creator?.past_experiences?.length == 0 &&
                    user?.creator?.sponsors?.length == 0 &&
                    user?.instagram_verified_at == null
                    ? "Start Verification"
                    : "Continue Verification"
                  : user?.role == "2" &&
                    user?.brand?.profile_complete == "0" &&
                    (user?.brand?.brand_industry === "" || user?.brand?.brand_industry === null) &&
                    (user?.brand?.established_date === "" || user?.brand?.established_date === null) &&
                    (user?.brand?.brand_social_interest === "" || user?.brand?.brand_social_interest === null) &&
                    (user?.brand?.bio === "" || user?.brand?.bio === null) &&
                    (user?.brand?.website_link === "" ||
                      user?.brand?.website_link === null) &&
                    (user?.brand?.instagram === "" ||
                      user?.brand?.instagram === null) &&
                    (user?.brand?.linkedIn === "" ||
                      user?.brand?.linkedIn === null) &&
                    (user?.brand?.profile_image_thumb === null ||
                      user?.brand?.profile_image_thumb === "")
                    ? "Start Verification"
                    : "Continue Verification"}
                <span className="ps-1">
                  &#x2192;
                </span>
              </div>
            </div>
          </>
        ) : null}
      </header>

      <main>
        <div>{children}</div>
      </main>

      {!hideFooter &&
        <footer className="tw-show-desktop">
          <Footer />
        </footer>}



    </div>
  );
};

export default AppLayout;
